<ds-message
  #dsMessage
  message="<strong>{{productUtils.getNameAndSupplierAlternativeAid(orderEntry?.product)}}</strong> {{'cartItems.removeProductSuccess' | cxTranslate}}"
  closable="true"
  highlighted="true"
  type="success"
></ds-message>
